<template>
  <transition name='modal'>
    <div class='modalcon'>
      <div class='modal-mask'>
        <div class='modal-wrapper'>
          <div class='modal-container' @click.stop>
            <span class='closebtn' @click='setPopup'>
              <i class='fa fa-close' aria-hidden='true'></i>
            </span>
            <div class='clearfix'></div>
            <div class='mbox'>
              <div class='modal-body mb0'>
                <!-- <div class="fbold text-center title" v-if="title">{{title}}</div> -->
                <!-- <p v-for="(str, index) in txtArr" :key="index">{{str}}</p> -->
                <div class="row justify-content-center align-content-center my-3">
                  <div>
                    <div class="text-uppercase">
                      <h2 class="app-download-header">
                        <b>{{title}}</b>
                      </h2>
                    </div>
                    <div class="d-flex justify-content-center align-content-center">
                      <a class="mr-3" @click="triggerEvent('playStore')">
                        <img class="app-store-logo clickable" src="https://tss-static-images.gumlet.io/icons/play-store.png"
                          alt="Download app on google play store"
                          title="Download app on google play store"
                        />
                      </a>
                      <a @click="triggerEvent('appStore')">
                        <img class="app-store-logo clickable" src="https://tss-static-images.gumlet.io/icons/app-store.png"
                          alt="Download app on apple app store"
                          title="Download app on apple app store"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
var $ = require('jquery')
window.jQuery = $

export default {
  props: ['setPopup', 'title', 'txtArr'],
  created () {
    $('body').addClass('_freeze')
  },
  beforeDestroy () {
    $('body').removeClass('_freeze')
  },
  methods: {
    checkUserAgent: function () {
      let ua = navigator.userAgent.toLowerCase()
      let isAndroid = ua.indexOf('android') > -1 // android check
      let isIphone = ua.indexOf('iphone') > -1 // ios check
      return {
        isAndroid,
        isIphone
      }
    },
    triggerEvent (device) {
      let store = 'https://bit.ly/appxtss'
      let iosLink = 'https://apps.apple.com/in/app/thesouledstore/id1493897434'
      let androidLink = 'https://play.google.com/store/apps/details?id=com.thesouledstore'
      let userAgent = this.checkUserAgent()
      const location = userAgent.isIphone ? 'thesouledstore://www.thesouledstore.com' : userAgent.isAndroid ? 'com.thesouledstore://www.thesouledstore.com' : null
      if (userAgent.isAndroid || userAgent.isIphone) {
        window.location = location
        setTimeout(function () { window.location = store }, 1000)
      } else {
        if (device === 'playStore') {
          window.location = androidLink
        } else if (device === 'appStore') {
          window.location = iosLink
        }
      }
    }
  }
}
</script>

<style lang='css' scoped>
.modal-header {
  border: none;
}

.notify-logo {
  margin: 0 auto;
  height: 120px;
  margin-top: -74px;
}

.closebtn {
  background-color: #e66a51;
  border-radius: 24px;
  padding: 2px 7px;
  color: #fff;
  position: absolute;
  margin-top: -17px;
  right: -12px;
  cursor: pointer;
}

.closebtn:hover {
  background: #e66a51;
}
.clickable{
  cursor: pointer;
}

.modalcon {
  position: fixed;
  display: block;
  left: 0;
  z-index: 9998;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-x: hidden;
  overflow-y: auto;
  transition: opacity 0.3s ease;
}

.modal-mask {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  transition: all 0.3s ease;
  position: relative;
}

.mbox {
  background: #fff;
  padding: 10px;
  padding-bottom: 0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  height: inherit;
  letter-spacing: 0px;
  text-align: left;
}

.modal-header,
.modal-body {
  padding: 5px 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-enter .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.app-download-header {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  line-height: 0.86;
  color: #282d3f;

}

.app-store-logo {
  height: 40px;
}

@media screen and (max-width: 768px) {
  .modal-container {
    width: 92%;
  }
}

@media screen and (max-width: 480px) {
  .mbox {
    padding: 0;
    height: inherit;
  }
  .notify-logo {
    height: 84px;
    margin-top: -40px;
  }
}
</style>



// WEBPACK FOOTER //
// commonPopUp.vue?5ff326d6